<template>
  <footer v-if="telaNaoFooter">
    <div class="footer_container limitW">
      <div class="buttonFooter">
        <router-link to="/home">
          <i class="fas fa-dolly-flatbed"></i>
          <p>Disponíveis</p>
        </router-link>
      </div>

      <div class="QR-CodeButton">
        <router-link to="/scanner">
          <i class="fas fa-qrcode"></i>
        </router-link>
      </div>

      <div class="buttonFooter">
        <router-link to="/home/uso">
          <i class="fas fa-dolly-flatbed"></i>
          <p>Em uso</p>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    telaNaoFooter() {
      return (
        this.$route.name != "Configuracao" && this.$route.name != "Dashboard"
      );
    },
  },
};
</script>

<style scoped>
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5rem;

  background: var(--bgColor);
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.253);
}
.footer_container {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.QR-CodeButton {
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.253);
  background: var(--colorPrimary);
  width: 5rem;
  min-width: 5rem;
  height: 5rem;
  min-height: 5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 2.3rem;
  position: relative;
  bottom: 2.5rem;
  cursor: pointer;
  z-index: 999999;
  position: fixed;
}
.QR-CodeButton a {
  color: var(--white);
  text-align: center;
}

.QR-CodeButton {
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.253);
  background: var(--colorPrimary);
  width: 5rem;
  min-width: 5rem;
  height: 5rem;
  min-height: 5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 2.3rem;
  position: relative;
  bottom: 1rem;
  cursor: pointer;
}
.QR-CodeButton a {
  color: var(--white);
  text-align: center;
}

.buttonFooter {
  text-align: center;
  padding: 0 1rem;
  width: 50%;
}
.buttonFooter a {
  font-weight: bold;
  color: var(--colorText-default);
}
.buttonFooter a.router-link-exact-active {
  color: var(--colorPrimary);
}
@media only screen and (max-width: 600px) {
  footer {
    height: 3.5rem;
  }
  .QR-CodeButton {
    bottom: 0.7rem;
    width: 4rem;
    min-width: 4rem;
    height: 4rem;
    min-height: 4rem;
  }
  .buttonFooter {
    position: relative;
    bottom: 0.6rem;
  }
}
</style>
